import React, { useState, useEffect } from "react";
import ProfilePictureAndCover from "./ProfilePictureAndCover/ProfilePictureAndCover";
import "assets/scss/partials/userprofile.scss";
import { useParams } from "react-router-dom";
import { useUserContext } from "store/contexts/userContext";
import UserService from "services/UserService";
import UserProfileData from "./UserProfileData/UserProfileData";
import UserAboutMe from "./UserAboutMe/UserAboutMe";
import Loader from "components/Loader";

const styles = {
  root: {
    minHeight: "100px",
    height: "100%",
    overflow: "auto",
    position: "relative",
    zIndex: 0,
    padding: 0,
  },
  content: {
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
  },
  tabsSection: {
    marginTop: "30px",
  },
  root_container: {
    width: "100%",
    maxWidth: "992px",
  },
  userTab: {
    padding: "10px 0",
  },
};

export default () => {
  const classes = styles;
  const params = useParams();
  const { user, setUser } = useUserContext();
  const [isOwner, setIsOwner] = useState(false);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    if (["undefined", null].includes(params.user_id)) {
      setUserProfile(user);
      setIsOwner(true);
      return;
    }
    try {
      (async () => {
        const response = await UserService.getUserProfile(params.user_id);
        if (user?.id === response.data.data.id) {
          setIsOwner(true);
        }
        setUserProfile(response.data.data);
      })();
    } catch (error) {
      console.log(error);
    }
    // eslint-disable-next-line
  }, [user, params.user_id]);

  return (
    <div style={classes.root}>
      <div style={classes.content}>
        {!userProfile && <Loader />}
        {userProfile && (
          <div className="col-md-12 col-lg-12" style={classes.root_container}>
            <ProfilePictureAndCover
              userProfile={userProfile}
              setUserProfile={setUserProfile}
              isOwner={isOwner}
            />
            <UserAboutMe
              profile={userProfile}
              setProfile={setUserProfile}
              isOwner={isOwner}
            />
            <UserProfileData
              profile={userProfile}
              user={user}
              setUser={setUser}
              setProfile={setUserProfile}
              isOwner={isOwner}
            />
          </div>
        )}
      </div>
    </div>
  );
};
